var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Multiselect } from '../Fields/Multiselect';
import { Select } from '../Fields/Select';
export class FormFields extends Component {
    constructor(isDebugEnabled = false) {
        super('FormFields', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.form *[data-key]').on(['change', 'keyup', 'click'], (event, field) => {
                FormFields.checkCondition();
                FormFields.checkCompany();
            });
            $('.form-field-multiselect').each((field) => {
                FormFields.fields.push(new Multiselect(field));
            });
            $('.form-field-select').each((field) => {
                FormFields.fields.push(new Select(field));
            });
            FormFields.update();
            FormFields.checkCondition();
            this.success();
        });
    }
    static update() {
        FormFields.fields.forEach((field) => {
            field.loadData();
        });
        FormFields.checkCondition();
        FormFields.checkCompany();
    }
    static checkCondition() {
        $('.form-field').each((field) => {
            let condition = atob(field.data('condition'));
            if (condition !== '') {
                let showField = false;
                try {
                    let targetField, prev;
                    if (condition.search('q_') !== -1) {
                        const consionsData = condition.split('.');
                        targetField = FormFields.getField(consionsData[0]);
                        condition = 'targetField.' + consionsData[1];
                    }
                    else {
                        prev = FormFields.getPreviousField(field);
                    }
                    showField = eval(condition);
                }
                catch (error) {
                    console.log(error);
                }
                if (showField) {
                    field.removeClass('d-none');
                }
                else {
                    field.addClass('d-none');
                }
            }
        });
    }
    static checkCompany() {
        // Check question 6
        const question6 = FormFields.getField('q_6');
        if (!question6)
            return;
        if (question6.count() > 0 && !question6.has('senior_55') && !question6.has('senior_66') && !question6.has('senior_80')) {
            $('#wrong-company').removeClass('d-none');
        }
        else {
            $('#wrong-company').addClass('d-none');
        }
    }
    static getField(key) {
        let returnField;
        FormFields.fields.forEach((field) => {
            if (field.key == key)
                returnField = field;
        });
        return returnField;
    }
    static getPreviousField(field) {
        return FormFields.getField(field.prev().find('*[data-key]').data('key'));
    }
}
FormFields.fields = [];
